/**
 * The selected vehicle type's MAP MARKER, shown beside the type picker (slice 58,
 * Mahad 24 Sep: "the admin picker must show the new designs, and the type must
 * stay changeable"). It inlines the SAME tracked SVG sources the marker generator
 * reads (docs/design/vehicles/<slug>-large.svg), so the picture here is the shape
 * the customer's map draws — not a second drawing that could drift.
 *
 * The body is `currentColor`; it is painted the admin's neutral text colour, never
 * a business-side state colour (green is the business side, indigo the admin —
 * never mixed).
 */
const SOURCES = import.meta.glob('../../../../docs/design/vehicles/*-large.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

/** vehicleType → SVG file slug (the web/app GLYPH_FOR_TYPE, as file names). */
export const PREVIEW_FILE: Record<string, string> = {
  sedan: 'sedan',
  suv: 'suv',
  land_cruiser: 'land-cruiser',
  pickup: 'pickup',
  van: 'minibus',
  truck: 'truck',
  tanker: 'water-tanker',
  bus: 'bus',
  motorcycle: 'motorbike',
  three_wheeler: 'threewheel',
  other: 'generic',
};

export function previewSvg(vehicleType: string): string | null {
  const slug = PREVIEW_FILE[vehicleType];
  if (!slug) return null;
  const entry = Object.entries(SOURCES).find(([path]) => path.endsWith(`/${slug}-large.svg`));
  return entry ? entry[1] : null;
}

export function VehicleTypePreview({ vehicleType, label }: { vehicleType: string; label: string }) {
  const svg = previewSvg(vehicleType);
  if (!svg) return null;
  return (
    <span
      data-testid="vehicle-type-preview"
      data-type={vehicleType}
      role="img"
      aria-label={label}
      className="flex h-16 w-10 flex-none items-center justify-center text-raad-text [&>svg]:h-full [&>svg]:w-auto [&>svg]:overflow-visible"
      // A static, tracked asset from this repository (never user input).
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
